(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesController', TabFilesController);

    TabFilesController.$inject = ['$scope', '$state', 'TabFiles', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'paginationConstants'];

    function TabFilesController($scope, $state, TabFiles, ParseLinks, AlertService, DataUtils, pagingParams, paginationConstants) {
        var vm = this;
        vm.tabFiles = [];
        vm.tabFilesInactive = [];
        vm.predicates = pagingParams.predicates;
        //vm.page = 0;      Modifica per impaginazione
        vm.loadPage = loadPage;
        vm.applyFilter = applyFilter;
        vm.charToSearch = pagingParams.search;
        vm.transition = transition;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-files";
        vm.currentStateFilter = "tab-files-filter";
        vm.tabFileType = pagingParams.tabFileType;
        vm.tabObjectType = pagingParams.tabObjectType;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        var filter = localStorage.getItem(vm.currentStateFilter);

        //Aggiunta per impaginazione
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;     //Pagination da aggiungere sopra ['']
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.tabFileType = filter.tabFileType;
                vm.tabObjectType = filter.tabObjectType;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,        //Modifica per impaginazione
                size: vm.itemsPerPageChosen,        //Modifica per impaginazione
                sort: sort(),
                query: vm.charToSearch
            };
            addFilter(body);
            TabFiles.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabFiles = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;      //Aggiunta per impaginazione
                vm.page = pagingParams.page;
                //vm.systemPage = pagingParams.systemPage;
                for (var i=0; i < data.length; ++i) {
                    vm.tabFiles.push(data[i]);
                    vm.loadInactive(data[i]);
                }
                if(vm.page === 0 && vm.page < vm.links['last']) {
                    vm.loadPage();
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.loadInactive = function(tabFiles) {
            TabFiles.load({name: tabFiles.fileAlias, idShowed : tabFiles.id}, null, onSuccess, onError);
            function onSuccess(data) {
                vm.tabFilesInactive[tabFiles.fileAlias] = [];
                vm.tabFilesInactive[tabFiles.fileAlias] = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(type, objectType) {
            var filter = {};
            filter.tabFileType = vm.tabFileType = type;
            filter.tabObjectType = vm.tabObjectType = objectType;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.tabFiles = [];
            vm.page = pagingParams.page;
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.tabFileType.id !== -1) {
                body.tabFileTypeId = vm.tabFileType.id;
            }
            if (vm.tabObjectType.id !== -1) {
                body.tabObjectTypeId = vm.tabObjectType.id;
            }
        }

        vm.reset = function () {
            vm.page = 0;
            vm.tabFiles = [];
            var orderCall = vm.loadAll();
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {           //Modifica per impaginazione
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();

    }
})();
